import { IUserState } from './user-states.store'
import { GetterTree } from 'vuex';

const getters: GetterTree<IUserState, {}> = <GetterTree<IUserState, {}>>{
    service: (state: IUserState) => state.service,
    listOfManagers: (state: IUserState) => state.listOfUsers,
    listOfUsers: (state: IUserState) => state.listOfUsers,
    authConfig: (state: IUserState) => state.authConfig,

    userInfo: (state: IUserState) => state.userInfo,
    userInfoOriginal: (state: IUserState) => state.userInfoOriginal,

    accountConfig: (state: IUserState) => state.accountConfiguration,
    accountConfigurationOriginal: (state: IUserState) => state.accountConfigurationOriginal,
    taskInAgenda: (state: IUserState) => state.accountConfiguration.TasksInAgenda,
    agenda: (state: IUserState) => state.accountConfiguration.Agenda,
    outlookSync: (state: IUserState) => state.accountConfiguration.OutlookSync,
    syncPersonInfo: (state: IUserState) => state.accountConfiguration.SyncPersonsInfo,
    exchangeConfig: (state: IUserState) => state.accountConfiguration.ExchangeConfig,

    twoFactorConfig: (state: IUserState) => state.twoFactorAuthenticate,
    twoFactorConfigOriginal: (state: IUserState) => state.twoFactorAuthenticateOriginal,

    notificationConfig: (state: IUserState) => state.notificationConfig,
    notificationConfigOriginal: (state: IUserState) => state.notificationConfigOriginal,

    userRights: (state: IUserState) => state.userRights,

}

export default getters;